/* ============================================================
   TELEPORTATION — Brand layer behaviour
   - header : état "scrolled" (masque le bandeau d'annonces)
   - menu plein écran
   - apparition au scroll ([data-tp-reveal])
   - tri de collection (auto-submit)
   - accordéons : charge les images dès l'ouverture
   - visionneuse photos produit (lightbox) + guide des tailles déplacé dans <body>
   - cartes produit : ajout direct au panier depuis la taille ([data-tp-quick-add])
   - panier : image + nom du produit cliquables vers la fiche produit
   - footer newsletter : message de succès / erreur seulement pour ce formulaire
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Header scrolled ---------- */
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      document.body.classList.toggle('tp-scrolled', window.scrollY > 40);
      ticking = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------- Menu ---------- */
  var menu = document.querySelector('[data-tp-menu]');
  var openBtn = document.querySelector('[data-tp-menu-open]');
  function openMenu() {
    if (!menu) return;
    menu.hidden = false;
    document.documentElement.classList.add('tp-menu-lock');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    requestAnimationFrame(function () { requestAnimationFrame(function () { menu.classList.add('is-open'); }); });
  }
  function closeMenu() {
    if (!menu) return;
    menu.classList.remove('is-open');
    document.documentElement.classList.remove('tp-menu-lock');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
    setTimeout(function () { menu.hidden = true; }, 350);
  }
  if (openBtn) openBtn.addEventListener('click', openMenu);
  document.querySelectorAll('[data-tp-menu-close]').forEach(function (b) { b.addEventListener('click', closeMenu); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && menu && !menu.hidden) closeMenu(); });

  /* ---------- Reveal ---------- */
  var revealEls = document.querySelectorAll('[data-tp-reveal]');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    revealEls.forEach(function (el) {
      var parent = el.parentElement;
      if (parent && parent.classList.contains('tp-grid')) {
        var idx = Array.prototype.indexOf.call(parent.children, el);
        el.style.transitionDelay = (idx % 4) * 70 + 'ms';
      }
      io.observe(el);
    });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------- Accordéons : images chargées à l'ouverture ---------- */
  document.querySelectorAll('details').forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (!d.open) return;
      d.querySelectorAll('img[loading="lazy"]').forEach(function (im) { im.loading = 'eager'; });
    });
  });

  /* ---------- Guide des tailles : sorti des sections (sinon fond transparent + sous le header) ---------- */
  var sizeModal = document.querySelector('[data-tp-pd-modal]');
  if (sizeModal) document.body.appendChild(sizeModal);

  /* ---------- Visionneuse photos produit ---------- */
  (function () {
    var media = Array.prototype.slice.call(document.querySelectorAll('[data-tp-pd-media]'));
    if (!media.length) return;
    var oldZoom = document.querySelector('[data-tp-pd-zoom]');
    if (oldZoom) oldZoom.remove();

    var lb = document.createElement('div');
    lb.className = 'tp-lb';
    lb.hidden = true;
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-label', 'Product images');
    lb.innerHTML =
      '<button type="button" class="tp-lb-x" aria-label="Close">&times;</button>' +
      '<button type="button" class="tp-lb-nav tp-lb-prev" aria-label="Previous image">&larr;</button>' +
      '<figure class="tp-lb-stage"><img alt=""></figure>' +
      '<button type="button" class="tp-lb-nav tp-lb-next" aria-label="Next image">&rarr;</button>' +
      '<div class="tp-lb-count"></div>';
    document.body.appendChild(lb);

    var img = lb.querySelector('img');
    var count = lb.querySelector('.tp-lb-count');
    var list = [];
    var i = 0;

    function srcOf(el) {
      var im = el.tagName === 'IMG' ? el : el.querySelector('img');
      return im ? (im.getAttribute('data-full') || im.currentSrc || im.src) : '';
    }
    function render() {
      img.classList.remove('is-in');
      img.src = list[i];
      count.textContent = (i + 1) + ' / ' + list.length;
      lb.classList.toggle('is-single', list.length < 2);
    }
    img.addEventListener('load', function () { img.classList.add('is-in'); });
    function open(items, at) {
      list = items; i = at || 0;
      render();
      lb.hidden = false;
      document.documentElement.classList.add('tp-menu-lock');
      requestAnimationFrame(function () { lb.classList.add('is-open'); });
    }
    function close() {
      lb.classList.remove('is-open');
      document.documentElement.classList.remove('tp-menu-lock');
      setTimeout(function () { lb.hidden = true; img.src = ''; }, 250);
    }
    function go(d) { if (list.length < 2) return; i = (i + d + list.length) % list.length; render(); }

    media.forEach(function (m) {
      m.addEventListener('click', function (e) {
        e.stopImmediatePropagation();
        var vis = media.filter(function (x) { return !x.hidden; });
        open(vis.map(srcOf), Math.max(0, vis.indexOf(m)));
      }, true);
    });
    document.querySelectorAll('.tp-pd-guide-img').forEach(function (g) {
      g.addEventListener('click', function (e) { e.stopImmediatePropagation(); open([srcOf(g)], 0); }, true);
    });

    lb.querySelector('.tp-lb-x').addEventListener('click', close);
    lb.querySelector('.tp-lb-prev').addEventListener('click', function () { go(-1); });
    lb.querySelector('.tp-lb-next').addEventListener('click', function () { go(1); });
    lb.addEventListener('click', function (e) { if (e.target === lb || e.target.classList.contains('tp-lb-stage')) close(); });
    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') go(-1);
      if (e.key === 'ArrowRight') go(1);
    });
    var sx = null;
    lb.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    lb.addEventListener('touchend', function (e) {
      if (sx == null) return;
      var dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1);
      sx = null;
    });
  })();

  /* ---------- Cartes produit : ajout direct au panier depuis une taille ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-tp-quick-add]');
    if (!b || b.disabled) return;
    e.preventDefault();
    var id = b.getAttribute('data-tp-quick-add');
    if (!id) return;
    var card = b.closest('.tp-pcard');
    var label = card && card.querySelector('.tp-pcard-quick-label');
    var old = label ? label.textContent : '';
    if (card) card.classList.add('is-adding');
    fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(id), quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (card) card.classList.remove('is-adding');
        if (res && res.status && res.status !== 200) { if (label) label.textContent = String(res.description || 'Try again'); }
        else {
          if (label) label.textContent = 'Added ✓';
          var cart = document.querySelector('[data-tp-cart-open]');
          if (cart) { cart.classList.remove('is-bumping'); void cart.offsetWidth; cart.classList.add('is-bumping'); cart.click(); }
        }
        setTimeout(function () { if (label) label.textContent = old; }, 1800);
      })
      .catch(function () { if (card) card.classList.remove('is-adding'); });
  });

  /* ---------- Panier : image + nom du produit cliquables vers la fiche produit ---------- */
  (function () {
    var lines = document.querySelector('[data-tp-cart-drawer-lines]');
    if (!lines) return;
    var urls = {};
    function apply() {
      Array.prototype.forEach.call(lines.querySelectorAll('[data-tp-cdline]'), function (l) {
        var u = urls[l.getAttribute('data-key')];
        if (!u || l.getAttribute('data-tp-linked')) return;
        l.setAttribute('data-tp-linked', '1');
        [l.querySelector('.tp-cart-drawer-line-img'), l.querySelector('.tp-cart-drawer-line-top span')].forEach(function (el) {
          if (!el) return;
          el.style.cursor = 'pointer';
          el.setAttribute('role', 'link');
          el.addEventListener('click', function () { window.location.href = u; });
        });
      });
    }
    new MutationObserver(function () {
      if (!lines.querySelector('[data-tp-cdline]:not([data-tp-linked])')) return;
      fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { c.items.forEach(function (it) { urls[it.key] = it.url; }); apply(); })
        .catch(function () {});
    }).observe(lines, { childList: true });
  })();

  /* ---------- Tri collection ---------- */
  document.querySelectorAll('[data-tp-sort] select').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  /* ---------- Footer newsletter ---------- */
  if (window.location.hash === '#tp-footer-news') {
    var ok = document.querySelector('[data-tp-footer-ok]');
    var err = document.querySelector('[data-tp-footer-err]');
    if (ok) ok.hidden = false;
    if (err) err.hidden = false;
  }
})();
